"use client";

import Link from "next/link";
import { useLang } from "./lang-provider";
import { Sprite } from "./sprite";

export function Footer() {
  const { lang, t } = useLang();
  const appStoreUrl = "https://apps.apple.com/app/apple-store/id6762003033?pt=128149478&ct=PaulOfficialWebsite&mt=8";
  const prefix = lang === "fr" ? "/fr" : "";
  return (
    <footer className="bento-footer">
      <div className="footer-left">
        <div className="footer-bear-wrap">
          <Sprite name="idle" scale={0.18} fps={6} startFrame={10} />
        </div>
        <span className="footer-copy">&copy; 2026 Maia</span>
      </div>
      <div className="footer-links">
        <Link href={`${prefix}/privacy`}>{t.privacy}</Link>
        <Link href={`${prefix}/terms`}>{t.terms}</Link>
        <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">App Store</a>
      </div>
    </footer>
  );
}
